  const state = {
  productInCook: false,
  tableId: "",
  productsOnTableUnavailable: [],
  navMyOrder : null,
  displayInfoOverlay: false,
  countProductsOrdered: 0,
  requesting: false,
  displayWarningNotTableid: false,
  waiterCalled :false
};

const getters = {
  tableId: state => {
    return state.tableId;
  }
};

const actions = {
};

const mutations = {
  setProductInCook(state, data) {
    state.productInCook = data;
  },
  SetNavigatorMyOrder(state,data) {
    state.navMyOrder = data;
  },
  setTableId(state, data) {
    state.tableId = data;
  },
  setProductsOnTableUnavailable(state, data) {
    state.productsOnTableUnavailable = data;
  },
  setDisplayInfoOverlay(state, data) {
    state.displayInfoOverlay = data;
  },
  setCountProductsOrdered(state, data) {
    state.countProductsOrdered = data;
  },
  setRequesting(state, data) {
    state.requesting = data;
  },
  setDisplayWarningNotTableid(state, data) {
    state.displayWarningNotTableid = data;
  },
  setWaiterCalled (state,data) {
    state.waiterCalled = data;
  }
};

export default {
  preserveState: true,
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
